import ko from "knockout";

import logger from "../logger";
import dateHelper from "../utils/dateHelper";

import { MaybeObservable } from "../interfaces/MaybeObservable";

declare global {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface KnockoutPunchesFilters {
        dateTimeFormat(maybeObs: MaybeObservable<string>, includeSeconds: boolean): string;
    }
}

ko.filters.dateTimeFormat = function (maybeObs: MaybeObservable<string>, includeSeconds: boolean = false) {
    const rawValue = ko.unwrap(maybeObs);
    try {
        return dateHelper.toLocalDateTimeFormat(rawValue, false, includeSeconds);
    } catch (e) {
        logger.error("dateTime filter error:", e);
        return rawValue; // Return the original value if transformation fails
    }
};
